import axios from "axios";
import ShowToast from "../../widget/common/ui/Toast";
import AppConfigService from "../app_config/AppConfigService";
import CacheStorage from "../storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import AppTranslation from "../app_translation/AppTranslation";
import LoginProvider from "../../provider/onboarding/login/LoginProvider";
import OnboardingProvider from "../../provider/onboarding/onboarding/OnboardingProvider";
import UtilityHelper from "../utilities/UtilityHelper";

const IS_DEBUG = process.env.NODE_ENV;

export default class ApiService {
  static postApi = async (
    url: string,
    body: any | FormData,
    initTokenStatus: boolean = false,
    isUpload: boolean = false,
    abort?: AbortSignal,
  ): Promise<any> => {
    try {
      const companyId: string = AppConfigService.get("company_id");
      const apiToken: string = CacheStorage.getValue(StorageKeys.api_token);

      if (!isUpload) {
        body = { ...body, company_id: companyId };
        if (!initTokenStatus) {
          body = { ...body, api_token: apiToken };
        }

        if (abort != null) {
        }
      } else {
        if (!body.has("company_id")) {
          body.append("company_id", companyId);
        }
        body.append("api_token", apiToken);
      }

      if (IS_DEBUG === "development") {
        console.log(`isUpload: ${isUpload}`);
        console.log(`url: ${url}`);
        console.log(body);
      }

      const dataResponse: any = await axios.post(url, body, {
        signal: abort ?? undefined,
        validateStatus: function (status) {
          // Resolve only if the status code is less than 500
          return status >= 200 && status < 500;
        },
      });

      const errorCode: number = parseInt(dataResponse.data["errorCode"] ?? 0);
      const companyCode: string = UtilityHelper.getUrlCompanyCode();

      console.log("DATA:", dataResponse);
      console.log("COMPANY CODE:", companyCode);
      console.log("ERROR CODE:", errorCode);

      let response: any = null;

      if (UtilityHelper.isNotEmpty(companyCode) && errorCode > 0) {
        if ([98].includes(errorCode)) {
          await OnboardingProvider.refreshToken();
          response = await this.postApi(url, body, initTokenStatus);
          //
        } else if ([99, 100].includes(errorCode)) {
          await OnboardingProvider.registerDevice(companyCode);
          response = await this.postApi(url, body, initTokenStatus);
          //
        }

        if (response != null) {
          return response;
        }
      }

      return dataResponse.data;

      /* if ([200].includes(parseInt(dataResponse.status))) {
        return dataResponse.data;
      } else {
        ShowToast.warning(AppTranslation.text("something_went_wrong"));
      } */
    } catch (e) {
      if (IS_DEBUG === "development") {
        if (axios.isCancel(e)) {
          console.log("Request canceled");
        } else if (e === "CanceledError") {
          console.log("Request aborted");
        } else {
          console.log(`Error: ${e}`);
          //console.error("Error:", e);
          ShowToast.warning(AppTranslation.text("something_went_wrong"));
        }
      } else {
        ShowToast.warning(AppTranslation.text("something_went_wrong"));
      }
    }

    return null;
  };

  static getApi = async (url: string): Promise<any | undefined> => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      const response = await fetch(url, { headers });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (err: any) {
      if (err.message.includes("Failed to fetch")) {
        ShowToast.warning("Please check your network");
      } else {
        ShowToast.warning(err.toString());
      }
      return undefined;
    }
  };
}
